import { applySeo } from "@/lib/seo-head";
import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import siteConfig from "@/config/site.json";

export const Route = createFileRoute("/aviso-legal")({
  component: AvisoLegalPage,
  head: (ctx) => applySeo(ctx.matches, ((_c: unknown) => ({
    meta: [
      { title: `Aviso Legal — ${siteConfig.brand.name}` },
      {
        name: "description",
        content:
          "Aviso legal e información general de RR Lex Juristas: titular del sitio, condiciones de uso y propiedad intelectual.",
      },
      { property: "og:title", content: `Aviso Legal — ${siteConfig.brand.name}` },
      {
        property: "og:description",
        content:
          "Aviso legal e información general de RR Lex Juristas: titular del sitio, condiciones de uso y propiedad intelectual.",
      },
      { property: "og:url", content: "https://rrlexjuristas.com/aviso-legal" },
    ],
    links: [
      { rel: "canonical", href: "https://rrlexjuristas.com/aviso-legal" },
    ],
  }))(ctx)),
});

function AvisoLegalPage() {
  const office = siteConfig.addresses[0];
  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-6 py-20">
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">Legal</p>
        <h1 className="text-4xl md:text-5xl font-serif mb-8">Aviso Legal</h1>
        <div className="gold-divider mb-10" />

        <div className="space-y-6 text-foreground/80 leading-relaxed">
          <h2 className="font-serif text-2xl text-foreground mt-2">1. Titular del sitio</h2>
          <p>
            Este sitio web es titularidad de {siteConfig.brand.name}, con
            domicilio profesional en {office.line}. Puede contactarnos en{" "}
            <a className="text-gold hover:underline" href={`mailto:${siteConfig.contact.emails[0].address}`}>
              {siteConfig.contact.emails[0].address}
            </a>
            .
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">2. Objeto</h2>
          <p>
            El presente aviso legal regula el uso del sitio web de{" "}
            {siteConfig.brand.name}, que tiene como finalidad informar sobre los
            servicios jurídicos prestados por el despacho.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">3. Condiciones de uso</h2>
          <p>
            El usuario se compromete a hacer un uso adecuado de los contenidos y
            servicios ofrecidos a través del sitio web, así como a no emplearlos
            para incurrir en actividades ilícitas o contrarias a la buena fe y
            al ordenamiento legal.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">4. Propiedad intelectual</h2>
          <p>
            Todos los contenidos del sitio (textos, imágenes, marcas, logos y
            diseño) son propiedad de {siteConfig.brand.name} o de sus
            respectivos titulares y están protegidos por la normativa de
            propiedad intelectual e industrial.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">5. Responsabilidad</h2>
          <p>
            {siteConfig.brand.name} no se hace responsable de los posibles
            daños o perjuicios derivados de interferencias, omisiones,
            interrupciones, virus informáticos, averías o desconexiones en el
            funcionamiento del sistema electrónico ajenas a su voluntad.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">6. Legislación aplicable</h2>
          <p>
            El presente aviso legal se rige por la legislación española. Para
            cualquier controversia, las partes se someten a los Juzgados y
            Tribunales del domicilio del despacho, salvo que la ley imponga
            otro fuero.
          </p>
        </div>
      </article>
    </Layout>
  );
}
